import { consola } from 'consola'

export function getCurrentTimeHHMM(): string {
  const now = new Date()
  const hours = now.getHours().toString().padStart(2, '0')
  const minutes = now.getMinutes().toString().padStart(2, '0')
  return `${hours}:${minutes}`
}

export function extractTimeFromISO(isoString: string): string {
  if (!isoString) return '00:00'
  try {
    const date = new Date(isoString)
    const hours = date.getUTCHours().toString().padStart(2, '0')
    const minutes = date.getUTCMinutes().toString().padStart(2, '0')
    return `${hours}:${minutes}`
  } catch (error) {
    consola.error('Error parsing time from ISO string:', error)
    return '00:00'
  }
}

export function isTimeInRange(time: string, from: string, to: string): boolean {
  const fromTime = from && from.includes('T') ? extractTimeFromISO(from) : from
  const toTime = to && to.includes('T') ? extractTimeFromISO(to) : to

  // Конец интервала ВКЛЮЧИТЕЛЬНО (на гранулярности минуты). Иначе конфиг вида
  // ночь 00:00–05:59 + день 06:00–23:59 оставлял минуту 05:59 без правила →
  // доставка падала в 0₽ (дыра). С `<=` сутки тайлятся без дыр и нахлёстов:
  // 05:59 → ночь, 06:00 → день. Совпадает с бэком (isSameOrBefore).
  if (fromTime > toTime) {
    return time >= fromTime || time <= toTime
  }
  return time >= fromTime && time <= toTime
}

export function formatTime(timeString: string): string {
  if (!timeString || !timeString.includes(':')) return timeString
  const [hours, minutes] = timeString.split(':')
  const hour = Number.parseInt(hours, 10)
  const min = Number.parseInt(minutes, 10)
  if (Number.isNaN(hour) || Number.isNaN(min)) return timeString
  return `${hour.toString().padStart(2, '0')}:${min.toString().padStart(2, '0')}`
}

export function isValidTime(time: string): boolean {
  if (!time || typeof time !== 'string') return false
  return /^([01]?\d|2[0-3]):[0-5]\d$/.test(time)
}

export function compareTime(time1: string, time2: string): number {
  if (!isValidTime(time1) || !isValidTime(time2)) {
    throw new Error('Invalid time format')
  }
  const [hours1, minutes1] = time1.split(':').map(Number)
  const [hours2, minutes2] = time2.split(':').map(Number)
  const totalMinutes1 = hours1 * 60 + minutes1
  const totalMinutes2 = hours2 * 60 + minutes2
  if (totalMinutes1 < totalMinutes2) return -1
  if (totalMinutes1 > totalMinutes2) return 1
  return 0
}
